var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('notification-group',{attrs:{"group":"app"}},[_c('div',{staticClass:"w-full sm:max-w-md fixed top-5 md:top-auto md:right-0 items-center justify-center z-50"},[_c('notification',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var notifications = ref.notifications;
var close = ref.close;
return [_vm._l((notifications),function(notification){return [_c('Flash',{key:notification.id,attrs:{"notification":notification,"close":close}})]})]}}])})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }